var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-block"},[_c('h4',{staticClass:"card-title"},[_vm._v("History")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Over the past 40 years Pizza Place has become known as the best pizza restaurant in Rochester NY, with over 25 locations in WNY and a full delivery menu!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c6a9a8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/History.vue
// module id = 60
// module chunks = 0